export class RoleNames {
    public static SITE_ADMIN = 'SITE_ADMIN';
    public static BILLING_ADMIN = 'BILLING_ADMIN';
    public static SUPPORT = 'SUPPORT';
    public static ORG_ADMIN = 'ORG_ADMIN';
    public static VENUE_ADMIN = 'VENUE_ADMIN';
    public static LOCATION_ADMIN = 'LOCATION_ADMIN';
    public static SERVER = 'SERVER';
}
